import { IEquatable } from './entity';
import { ILocalizable } from './localized';

export type ITemplate = {
  id: IEquatable;
  name: ILocalizable;
  collections: string[];
};
